<template>
  <CanvasJSChart :options="options" :styles="styleOptions"/>
</template>  

<script>  
    export default {
      data() {
        return {
          options: {
            theme: "light2",
            animationEnabled: true,
            data: [{
            type: "doughnut",
            startAngle: 145,
            dataPoints: [
              { label: "", y: 35, color: "#F9F5FF" },
              { label: "", y: 20, color: "#7A7A7A" },
              { label: "", y: 35, color: "#222222" },
              { label: "", y: 10, color: "#F9B848" }

            ],
            innerRadius: "50%", // Outer chart's inner radius
            radius: "100%"  // Outer chart's outer radius
          }]
          },
          styleOptions: {
            width: "360px",
            height: "360px"
          }
        }
      }
    }

</script>
                              
  
  <style>
  .canvasjs-chart-credit {
    display: none !important;
  }
  </style>
  